import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredMachines,
  selectMachineFilterVisible,
  selectMachineLoading,
  selectfetchMachineLoading
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Printer } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import MachinePrintModal from './machine-print-modal';

import { actions as machineActions } from './store/slice';

const { setMachine } = machineActions;

const { CELL_ADD_EDIT } = MODAL_TYPES;

const MachineTile = ({ activeLane }) => {

  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const machineTileRef = useRef(null);
  const filteredMachines = useSelector(selectFilteredMachines);
  const isLoading = useSelector(selectMachineLoading);
  const filterVisible = useSelector(selectMachineFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);
  const isFetchDataLoading = useSelector(selectfetchMachineLoading);

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [selectedCellNumber, setSelectedCellNumber] = useState(null);

  const updateColumnSettings = useCallback(() => {
    if (machineTileRef.current) {
      const width = machineTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const handlePrintClick = (machine) => {
    setSelectedAssetId(machine.assetNumber);
    setSelectedCellNumber(machine.cellNumber);
    setShowPrintModal(true);
  };

  const itemData = filteredMachines.map(machine =>
    <Tile machine={machine} onPrint={() => handlePrintClick(machine)} />
  );

  return (
    <div
      className={`tile-body border-left ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''
        }`}
      ref={machineTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredMachines.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
      <MachinePrintModal
        showModal={showPrintModal}
        onCloseModal={() => setShowPrintModal(false)}
        assetId={selectedAssetId}
        cellNumber={selectedCellNumber}
      />
    </div>
  );
};

const Tile = ({ machine, onPrint }) => {


  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(setMachine(machine));
    dispatch(showModal(CELL_ADD_EDIT, machine));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deleteMachine(machine.processId));
  };

  return (
    <div key={machine.processId || Math.random()} className="tile">
      <div
        className={`card p-3 m-2 ${machine.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={(e) => {
              e.stopPropagation();
              onPrint();
            }}>
              <Printer size={16} />
            </Button>
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0 truncate-2lines" title={machine.brand}>{machine.brand} </h6>
              <span className="text-muted fa-sm">{machine.tonnage || '--'}</span>
            </div>
          </div>
        </div>
        <div className="ms-2">
          <div className="mt-2 d-flex flex-column justify-content-center" style={{ lineHeight: '1rem' }}>
            <h6 className="heading mb-2">{machine.assetNumber || '--'}</h6>
            <h6 className="border-top pt-2 heading">{machine.cellNumber}</h6>
          </div>
        </div>

      </div>
    </div>
  );
};

export default MachineTile;
